import { render, staticRenderFns } from "./TextJudy.vue?vue&type=template&id=79786089&scoped=true&"
import script from "./TextJudy.vue?vue&type=script&lang=js&"
export * from "./TextJudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79786089",
  null
  
)

export default component.exports